module.exports = __webpack_public_path__ + "img/DE01921.1515ddb7.png";